import useApi from "../useApi";
import { CapabilityInterface } from "../../interfaces/CapabilityInterface";

interface UseGetCapabilityInterface {
  getById: (id: string) => Promise<CapabilityInterface | null>;
}

const useGetCapability = (): UseGetCapabilityInterface => {
  const { get } = useApi();

  const getById = async (id: string): Promise<CapabilityInterface | null> => {
    const { data, status } = await get(`/capability/${id}`);

    if (status !== 200) {
      // todo
      throw new Error("Unknown");
    }

    return data;
  };

  return { getById };
};

export default useGetCapability;
